import Phrase from "../Phrase/Phrase";
import { ISayPhraseOrConfirmationProps } from "./SayPhraseOrConfirmation.props";
import styles from "./SayPhraseOrConfirmation.module.scss";

const SayPhraseOrConfirmation = ({
	action,
	idx,
	channel,
	isDisabled,
	showPhraseList,
	setShowPhraseList,
	handleSaveActionInStore,
}: ISayPhraseOrConfirmationProps): JSX.Element => {
	return (
		<div className={styles.phrases}>
			{/* первая фраза */}
			<Phrase
				key={"first-phrase"}
				phrase={action.text[0] || ""} // обработка кривых данных бэка
				idxPhrase={0}
				arrayPhrases={action.text}
				channel={channel}
				idxAction={idx}
				isDisabled={isDisabled}
				multiline={showPhraseList}
				showPhraseList={showPhraseList}
				setShowPhraseList={setShowPhraseList}
				handleSaveActionInStore={handleSaveActionInStore}
			/>

			{/* кроме первой фразы */}
			{showPhraseList &&
				action.text
					.concat("") // поле для добавления
					.map(
						(phrase, idxPhrase) =>
							idxPhrase !== 0 && (
								<Phrase
									key={idxPhrase}
									phrase={phrase}
									idxPhrase={idxPhrase}
									arrayPhrases={action.text}
									channel={channel}
									idxAction={idx}
									isDisabled={isDisabled}
									showPhraseList={showPhraseList}
									setShowPhraseList={setShowPhraseList}
									handleSaveActionInStore={handleSaveActionInStore}
								/>
							)
					)}
		</div>
	);
};

export default SayPhraseOrConfirmation;
